<template>
    <rkm-modal
        :loading="loading"
        :title="title"
        extraLarge
        ref="Modal"
        hide-footer
    >
        <Form
            :disable-filters="disableFilters"
            @select="handleExit"
        />
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    props: {
        disableFilters: { type: Boolean },
        title: { type: String, default: 'Não sei meu CEP' },
    },
    methods: {
        open() {

            this.$refs.Modal.show()
        },
        handleExit(logradouro) {

            this.$emit('select', logradouro)

            this.$refs.Modal.hide()
        },
    }
}
</script>